document.addEventListener("DOMContentLoaded", function () {
  // Hide any mobile slideshow containers
  const mobileSlides = document.querySelectorAll('.slideshow--mobile, .mobile-only');
  mobileSlides.forEach(slide => slide.style.display = 'none');

  // Force desktop slideshow container to be visible
  const desktopSlides = document.querySelectorAll('.slideshow');
  desktopSlides.forEach(slide => {
    slide.style.display = 'block';
    slide.style.visibility = 'visible';
  });
});
